import { makeStyles } from '@material-ui/core'

// FormControlLabel is inline-flex. Rendered in a bare sequence, ~40 of them
// flow as one wrapped paragraph and the Save buttons land mid-line, which is
// what this screen looked like. Every rule here exists to give that sequence
// a block structure.
const useStyles = makeStyles((theme) => ({
  // One row per category rather than one entry per category+channel pair. The
  // flat form repeated the category name once per channel, so three quarters
  // of the text on the screen was duplication.
  categoryRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  categoryName: {
    flex: '0 0 auto',
    minWidth: 280,
    fontSize: 14,
    // The keys are dotted identifiers with no spaces, so they do not wrap at
    // a sensible point and would otherwise force the row wider than the panel.
    wordBreak: 'break-word',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },
  channelGroup: {
    flex: '1 1 auto'
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(2)
  },
  subHeading: {
    paddingTop: theme.spacing(2)
  }
}))

export default useStyles
